import axiosClient from "api/apiClient";

interface IOptions {
    id?: string;
    sort?: string;
    search?: string;
}

export const APIGetCustomSubcategory = (options: IOptions) => {
    let sort = "";
    let search = "";
    if (options.hasOwnProperty("sort")) {
        sort = "&sort=" + options.sort;
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.sort;
    }
    return axiosClient.get(`/personal-items-subcategories/${options.id}?${search}${sort}`);
};

export const APIArchiveCustomSubcategory = (options: IOptions) => {
    return axiosClient.post(`/personal-items-subcategories/archive/${options.id}`);
};

export const APIRestoreCustomSubcategory = (options: IOptions) => {
    return axiosClient.post(`/personal-items-subcategories/restore/${options.id}`);
};

export const APIUpdateCustomSubcategory = (id: string, data: object) => {
    return axiosClient.put(`/personal-items-subcategories/${id}`, data);
};

export const APIPostCustomSubcategory = (data: object) => {
    return axiosClient.post(`/personal-items-subcategories`, data);
};
